import { API_URL, PUBLIC_ROOT_URL, PUBLIC_URL } from '../config';

let supportsWebp = null;
let supportsAvif = null;

const detectWebpSupport = async () => {
    const elem = document.createElement('canvas');
    // eslint-disable-next-line no-extra-boolean-cast
    if (!!(elem.getContext && elem.getContext('2d'))) {
        return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    }
    return false;
};

const detectAvifSupport = () => new Promise((resolve) => {
    const image = new Image();
    image.onerror = () => resolve(false);
    image.onload = () => resolve(true);
    image.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=";
});

detectAvifSupport().then((v) => supportsAvif = v);
detectWebpSupport().then((v) => supportsWebp = v);

export const getPictureLink = (url = '', args = {}, alpha = false) => {
    if (!url) {
        return null;
    }

    // Define output format
    const output = (() => {
        if (supportsAvif) {
            return 'avif';
        }
        if (supportsWebp) {
            return 'webp';
        }
        return alpha ? 'png' : 'jpg';

    })();

    // Define quality
    const q = {
        webp: 60,
        jpg: 75,
        png: 100,
        avif: 50,
    }[output] || 100;

    const params = new URLSearchParams({
        ...args,
        ...(args.w ? { w: Math.round(args.w) } : {}),
        ...(args.h ? { h: Math.round(args.h) } : {}),
        ...(url ? { url } : {}),
        ...(alpha === false ? { bg: '#FFF' } : {}),
        output,
        q,
        il: '',
        l: '',
        ...(PUBLIC_ROOT_URL !== '/' ? { default: `${PUBLIC_ROOT_URL}blank.gif` } : {}),
        ...(PUBLIC_URL !== '/' ? { default: `${PUBLIC_URL}blank.gif` } : {}),
    }).toString();

    return `${API_URL}resize?${params}`;
};

export const pickSmallestSupportedSourceUrl = (sources = []) => {
    const sortedSources = [...sources].sort((a, b) => a.size - b.size);
    for (const source of sortedSources) {
        if (supportsAvif && source.format === 'avif') {
            return source.url;
        }
        if (supportsWebp && source.format === 'webp') {
            return source.url;
        }
        if (['jpeg', 'jpg', 'png'].includes(source.format)) {
            return source.url;
        }
    }
    return null;
}
